import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiMe, apiLogin, apiRegister, apiLogout, apiUpdateProfile } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    apiMe()
      .then((u) => { if (alive) setUser(u); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const login = async (email, password) => {
    const u = await apiLogin(email, password);
    setUser(u);
    return u;
  };
  const register = async (email, password, name) => {
    const u = await apiRegister(email, password, name);
    setUser(u);
    return u;
  };
  const logout = async () => {
    await apiLogout();
    setUser(null);
  };
  const updateProfile = async (fields) => {
    const u = await apiUpdateProfile(fields);
    setUser(u);
    return u;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
